// @flow
import React from 'react';

const reInternalHostname = /bench\.co$/;
type GeneralRequestProps = {
  title: string,
  inline?: boolean,
  hasLink?: boolean,
  fallbackUrl: string,
};
export default function GeneralRequest({
  title,
  inline,
  hasLink,
  fallbackUrl,
}: GeneralRequestProps) {
  // eslint-disable-line object-curly-newline
  const isInternal = reInternalHostname.test(new URL(fallbackUrl).hostname);
  const targetProps = isInternal
    ? {}
    : {
        target: '_blank',
        rel: 'noopener noreferrer',
      };
  const content = hasLink ? (
    <a href={String(fallbackUrl)} {...targetProps}>
      {title}
    </a>
  ) : (
    title
  );
  const Tag = inline ? 'span' : 'div';
  return <Tag data-test-id={`general-request-${hasLink ? 'with' : 'without'}-link`}>{content}</Tag>;
}

GeneralRequest.defaultProps = {
  inline: false,
  hasLink: false,
};
